import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function rotatingWords() {
  const rotating = document.querySelector('[data-name="rotating-words"]')

  if (rotating) {
    const wrapper = rotating.querySelector(
      '[data-name="rotating-words-wrapper"]'
    )

    const amountToScroll = wrapper.getBoundingClientRect().width

    gsap.to(wrapper, {
      scrollTrigger: {
        trigger: rotating,
        start: 'top 65%',
        end: '5% top',
        scrub: 4,
      },
      x: -amountToScroll,
      duration: 7,
      ease: 'none',
    })
  }
}

export { rotatingWords }
